<script>
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";

export default {
    name: "VAutocompleteRoles" ,
    inheritAttrs: false,
    components: {
        AjaxLoad,
    },
    props: {
        value: {},
        roles: {
            type: Array,
        },
        multiple: {
            type: Boolean,
        }
    },
    data() {
        return {
        };
    },
    computed: {
        syncValue: {
            get() {
                return this.value;
            },
            set(v) {
                this.$emit('input', v);
            },
        },
    },
}
</script>

<template>
    <ajax-load
        :url="$apiUrl.getRolesUrl()"
        :transform="response => response.data.data"
        v-slot="{data, resolved}"
    >
        <v-autocomplete
            v-bind="$attrs"
            v-on="$listeners"
            v-model="syncValue"
            :items="data"
            :loading="!resolved || undefined"
            :class="[$vnode.data.class, $vnode.data.staticClass]"
            item-value="id"
            item-text="name"
            label="Роль"
        ></v-autocomplete>
    </ajax-load>
</template>

<style scoped lang="scss">

</style>
